import React, { Component, Fragment } from "react";
import { inject } from "mobx-react";
import { getCurrency } from "../../services/cities";

@inject("CheckInStore")
class Confirmation extends Component {
  render() {
    const {CheckInStore} = this.props
    return (
      <div className={`${this.props.base}__section-area`}>
        <ul>
          <li>
            <span>Bag number </span>
            <span className="text--bold">{CheckInStore.checkinData.backpack_id}</span>
          </li>
          <li>
            <span>Cooler bag number </span>
            <span className="text--bold">{CheckInStore.checkinData.cooler_bag_id}</span>
          </li>
          <li>
            <span>Cash on delivery </span>
            <span className="text--bold">{getCurrency()}{CheckInStore.checkinData.returned_cash}</span>
          </li>
          {!CheckInStore.isReturn &&
            <Fragment>
              <li>
                <span>Checklist </span>
                <span className="text--bold">
                  {CheckInStore.checkinData.checklist_signed ? "Signed" : null}
                </span>
              </li>
              <li>
                <span>Dispatches </span>
                <span className="text--bold">{(CheckInStore.checkinData.dispatches).join(', ')}</span>
              </li>
              <li>
                <span>Backup? </span>
                <span className="text--bold">{CheckInStore.checkinData.backup ? "Yes" : "No"}</span>
              </li>
            </Fragment>
          }
        </ul>
      </div>
    );
  }
}

export default Confirmation;



// WEBPACK FOOTER //
// ./src/components/checkIn/Confirmation.js